




























































import type { Product } from "@constructor/shared-entity/type";
import { defineComponent, type PropType } from "vue-demi";
import GGPrice from "./GGPrice.vue";
import ProductDiscountMarker from "../shared/ProductDiscountMarker.vue";
import BonusCount from "../shared/BonusCount/BonusCount.vue";
import CartTool from "../shared/CartTool/CartTool.vue";
import type { UserCartItem } from "../../type/UserCart";
import type { SectionMeta } from "../../type/SectionMeta";

export default defineComponent({
  name: "GGProduct",
  components: {
    GGPrice,
    ProductDiscountMarker,
    BonusCount,
    CartTool,
  },
  props: {
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
    size: {
      type: String as PropType<"regular" | "big">,
      default: "regular",
    },
    userCartItem: {
      type: Object as PropType<UserCartItem | null>,
      default: null,
    },
    cart: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    meta: {
      type: Object as PropType<SectionMeta>,
      default: () => ({}),
    },
    sliderGridStyles: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  emits: {
    "cart-add": (_: string) => true,
    "cart-remove": (_: string) => true,
    "auth-needed": () => true,
  },
});
